export default "__VITE_ASSET__KA3zAq_G__"